import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space } from "antd";
import { SearchOutlined, FileDoneOutlined, FileTextOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../services/http";
import dayjs from "dayjs";

export const Treinamentos = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // FILTRO
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarTreinamentos();
  }, []);

  // LISTAR
  const listarTreinamentos = async () => {
    setLoading(true);
    const api = await http("get", `v1/treinamentos/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Treinamento",
      dataIndex: "treinamento",
      sorter: (a, b) => a?.treinamento?.localeCompare(b?.treinamento),
    },
    {
      title: "Entidade",
      dataIndex: "entidade",
      sorter: (a, b) => a?.entidade?.localeCompare(b?.entidade),
    },
    {
      title: "Carga Horária",
      dataIndex: "carga",
      render: (_, e) => e?.carga + " hr(s)",
      sorter: (a, b) => a?.carga?.localeCompare(b?.carga),
    },
    {
      title: "Data Início",
      dataIndex: "data_inicio",
      render: (_, e) => dayjs(e?.data_inicio).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a?.data_inicio).format("DD/MM/YYYY")?.localeCompare(dayjs(b?.data_inicio).format("DD/MM/YYYY")),
    },
    {
      title: "Data Fim",
      dataIndex: "data_fim",
      render: (_, e) => dayjs(e?.data_fim).format("DD/MM/YYYY"),
      sorter: (a, b) => dayjs(a?.data_fim).format("DD/MM/YYYY")?.localeCompare(dayjs(b?.data_fim).format("DD/MM/YYYY")),
    },
    {
      title: "Ações",
      width: 50,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Detalhes">
            <Button
              loading={loading}
              onClick={() => navigate(`/treinamentos/detalhes/${e.id}`)}
              icon={<FileTextOutlined />}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.treinamento?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.entidade?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.carga?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val?.data_inicio).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val?.data_fim).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate("/treinamentos/lancamento/grupos")}
            />
            <HeaderTitle
              title="Meus Certificados"
              subtitle="Consultar meus treinamentos realizados"
              icon={<FileDoneOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
